// Kindle Research Pro - Variant A: Strict Paywall
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Layout } from '../Layout';

export default function KindleVariantA({ PaywallHero, TutorialPreview, navigate, sharedProps }) {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="container mx-auto px-4 py-12">
          <PaywallHero 
            variant="A"
            {...sharedProps}
          />
          <div className="max-w-4xl mx-auto mt-12">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">Free Preview: How Kindle Research Works</CardTitle>
              </CardHeader>
              <CardContent>
                <TutorialPreview />
                <div className="mt-6 text-center">
                  <Button onClick={() => navigate('/kdp-setup-guide')} variant="outline">
                    Read Full KDP Setup Guide (Free)
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  );
}
